import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import {
  renderTextField,
  requiredValidator,
  renderNumberField,
  renderDatePicker
} from 'utils/formHelper';
import { updateRepaymentStatus } from 'actions/repayments';
import date from 'utils/date';
import moment from 'moment';

const styleSheet = (theme) => ({
  overdue: {
    color: theme.palette.error.main
  }
});

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false }
  };

  submit = (attrs) => {
    const { dispatch, repayment, mode } = this.props;
    const action = updateRepaymentStatus(repayment.id, repayment.loanId, attrs.status);
    return dispatch(action)
      .then(this.handleClose)
      .catch(this.handleSubmitFailure);
  }

  handleSubmitFailure = (error) => {
    if (error && error.response) {
      throw new SubmissionError(error.response);
    }
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  renderForm = () => {
    return (
      <div>
        <div className='form-row' >
          <Field
            select
            name='status'
            component={renderTextField}
            label='Repayment Status'
            validate={requiredValidator}
          >
            {
              [
                'paid',
                'unpaid',
                'cleared',
              ].map(option => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))
            }
          </Field>
        </div>
      </div>
    );
  }

  title = () => {
    return 'Update Repayment';
  }

  render = () => {
    const { open } = this.state;
    const {
      classes,
      handleSubmit,
      buttonLabel,
      buttonStyles,
      reset,
      repayment
    } = this.props;

    return (
      <div>
        <Button
          className={repayment.statusToDate == "overdue" && classes.overdue}
          onClick={() => this.setState({ open: true })}
        >
          {buttonLabel}
        </Button>
        <Dialog
          open={open}
          onEnter={reset}
          onClose={this.handleClose}
        >
          <form onSubmit={ handleSubmit(this.submit) }>
            <DialogTitle>
              { this.title() }
            </DialogTitle>
            <DialogContent style={{ width: 500 }}>
              { this.renderForm() }
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose}>CANCEL</Button>
              <Button type='submit' color='primary'>SUBMIT</Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const initialValues = { ...ownProps.repayment }
  return { ...initialValues };
};

const reduxed = reduxForm({ enableReinitialize: true })(Form);
const connected = connect(mapStateToProps)(reduxed);
export default withStyles(styleSheet)(connected);



// WEBPACK FOOTER //
// ./src/components/Loans/RepaymentForm.js